if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )

      const searchId = this.openedBy.getAttribute("data-media-id");
      let activeMedia = this.querySelector(`[data-media-id="${searchId}"]`);

      if (!activeMedia) {
        // Gallery and modal may use different ID types (file-ref vs media ID) when the
        // variant_images metafield is set. Fall back to matching by slide position — find
        // the clicked <li> in its gallery slider and show the same-indexed image in the modal.
        const gallerySlide = this.openedBy.closest('li[data-media-id]');
        if (gallerySlide) {
          const allSlides = Array.from(gallerySlide.parentElement.querySelectorAll('li[data-media-id]'));
          const slideIndex = allSlides.indexOf(gallerySlide);
          const modalImages = Array.from(this.querySelectorAll('[data-media-id]'));
          if (slideIndex >= 0 && slideIndex < modalImages.length) {
            activeMedia = modalImages[slideIndex];
          }
        }
      }

      if (!activeMedia) return;
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      if (activeMedia.nodeName === 'IMG' && !activeMedia.complete) {
        activeMedia.src = activeMedia.getAttribute('src');
      }
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  });
}
